import { render, staticRenderFns } from "./rulesStatus.vue?vue&type=template&id=1f25e3ea&scoped=true&"
import script from "./rulesStatus.vue?vue&type=script&lang=js&"
export * from "./rulesStatus.vue?vue&type=script&lang=js&"
import style0 from "./rulesStatus.vue?vue&type=style&index=0&id=1f25e3ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f25e3ea",
  null
  
)

component.options.__file = "rulesStatus.vue"
export default component.exports